/* eslint-disable no-console */
import {
  countryToLanguageMap,
  LangList,
} from '@/shared/components/atoms/LanguageSelector/languagesList';

export const detectUserGeoInfo = async (): Promise<{
  language: string;
  countryCode: string;
}> => {
  try {
    // Using ipapi.co service (free tier allows 1000 requests/day)
    const response = await fetch('https://ipapi.co/json/');
    const data = await response.json();
    const countryCode = data.country;

    // Get the mapped language or fallback to English
    const detectedLanguage = countryToLanguageMap[countryCode];

    // Check if the detected language is supported in our LangList
    if (detectedLanguage && LangList[detectedLanguage]) {
      return { language: detectedLanguage, countryCode: countryCode };
    }

    /**
     * Fallback to browser's language if supported
     * @info the geolocation services might be blocked by
     * some users' privacy settings or ad blockers.
     * That's why we have the fallback to browser language and ultimately to English.
     * */
    const browserLang = navigator.language.split('-')[0];
    // const browserCountryCode = navigator.
    if (LangList[browserLang]) {
      return { language: browserLang, countryCode };
    }

    // Default fallback to English
    return { language: 'en', countryCode };
  } catch (error) {
    console.error('Error detecting user language:', error);
    return { language: 'en', countryCode: 'EG' };
  }
};

export function getTextDirection(text: string): 'rtl' | 'ltr' {
  const rtlCharPattern = /[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/;

  return rtlCharPattern.test(text) ? 'rtl' : 'ltr';
}
